import { render, staticRenderFns } from "./ProductReportDetail.vue?vue&type=template&id=6dbdaa0c&scoped=true&"
import script from "./ProductReportDetail.vue?vue&type=script&lang=js&"
export * from "./ProductReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductReportDetail.vue?vue&type=style&index=0&id=6dbdaa0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbdaa0c",
  null
  
)

export default component.exports